module.exports = __webpack_public_path__ + "static/avstandetsbla-e6f3388f185270ebb85791b9254b502b.mp4";